import { PredictionDataType } from './types';

export const predictionInitialState: PredictionDataType = {
  vkId: undefined,
  predictionParams: undefined,
};
